import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';
import PixieDust from '../components/PixieDust';

const CastleIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M3 21h18M3 7v14M21 7v14M6 21V11l6-4 6 4v10M9 21v-4h6v4M3 7l3-4M21 7l-3-4M3 7h18M7 3h2M15 3h2"/>
  </svg>
);

const SparkleIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.636 5.636l2.122 2.122M16.243 16.243l2.121 2.121M5.636 18.364l2.122-2.122M16.243 7.757l2.121-2.121"/>
    <circle cx="12" cy="12" r="3"/>
  </svg>
);

const TargetIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="10"/>
    <circle cx="12" cy="12" r="6"/>
    <circle cx="12" cy="12" r="2"/>
  </svg>
);

const StarIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
  </svg>
);

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" width="20" height="20">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
    <circle cx="12" cy="12" r="4"/>
    <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" stroke="none"/>
  </svg>
);

const CheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" width="14" height="14">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);

const About = () => {
  return (
    <div className="about-page">
      <section className="about-hero">
        <PixieDust count={9} className="pixie-dust--short" />
        <div className="container">
          <div className="about-hero-content">
            <div className="about-hero-image">
              <div className="avatar-placeholder-large" aria-hidden="true">CH</div>
            </div>
            <div className="about-hero-text">
              <h1>About Chrystal Harris</h1>
              <p className="tagline">Your Disney Travel Consultant &amp; Dream Maker</p>
              <p>
                With over a decade of experience in Disney travel planning, I've helped
                hundreds of families create unforgettable memories at the most magical
                places on earth. From first-time visitors to seasoned Disney veterans,
                I'm here to make your Disney dreams come true.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="about-details">
        <div className="container">
          <div className="details-grid">
            <div className="detail-card">
              <div className="detail-icon"><CastleIcon /></div>
              <h3>Disney Expertise</h3>
              <p>
                I've visited every Disney park multiple times and stay up-to-date on
                all the latest attractions, dining options, and insider tips to ensure
                your vacation is nothing short of magical.
              </p>
            </div>

            <div className="detail-card">
              <div className="detail-icon"><SparkleIcon /></div>
              <h3>Personalized Planning</h3>
              <p>
                Every family is unique, and so should be your Disney vacation. I take
                the time to understand your specific needs, preferences, and budget to
                create a truly personalized experience.
              </p>
            </div>

            <div className="detail-card">
              <div className="detail-icon"><TargetIcon /></div>
              <h3>Money-Saving Tips</h3>
              <p>
                Disney vacations can be expensive, but they don't have to break the bank.
                I know all the tricks to maximize your experience while keeping costs
                under control.
              </p>
            </div>

            <div className="detail-card">
              <div className="detail-icon"><StarIcon /></div>
              <h3>Ongoing Support</h3>
              <p>
                My service doesn't end when you book your trip. I'm here throughout
                your entire journey to answer questions, make adjustments, and ensure
                everything goes smoothly.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="about-story">
        <div className="container">
          <div className="story-content">
            <h2>My Disney Story</h2>
            <div className="story-text">
              <p>
                My love affair with Disney began when I was just a little girl, visiting
                Disney World for the first time with my family. The moment I walked down
                Main Street, U.S.A. and saw Cinderella Castle for the first time, I knew
                I was in a truly magical place.
              </p>
              <p>
                As I grew older, my passion for Disney only deepened. I started planning
                trips for friends and family, researching every detail to ensure they had
                the most magical experience possible. What started as a hobby quickly
                became my calling.
              </p>
              <p>
                Today, I'm proud to be a certified Disney travel consultant, helping
                families from all over the world create their own magical memories.
                There's nothing more rewarding than seeing the joy on a child's face
                when they meet their favorite character, or helping couples plan their
                perfect Disney honeymoon.
              </p>
              <p>
                Whether you're planning your first Disney vacation or your fiftieth,
                I'm here to make sure every moment is filled with wonder, excitement,
                and pure Disney magic.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="about-services">
        <div className="container">
          <h2>How I Can Help You</h2>
          <div className="services-grid">
            <div className="service-item">
              <h3>Vacation Planning</h3>
              <ul>
                <li><CheckIcon /><span>Custom itinerary creation</span></li>
                <li><CheckIcon /><span>Resort recommendations</span></li>
                <li><CheckIcon /><span>Dining reservations</span></li>
                <li><CheckIcon /><span>FastPass+ strategy</span></li>
                <li><CheckIcon /><span>Transportation planning</span></li>
              </ul>
            </div>

            <div className="service-item">
              <h3>Booking Services</h3>
              <ul>
                <li><CheckIcon /><span>Resort reservations</span></li>
                <li><CheckIcon /><span>Park tickets</span></li>
                <li><CheckIcon /><span>Dining packages</span></li>
                <li><CheckIcon /><span>Special events</span></li>
                <li><CheckIcon /><span>Travel insurance</span></li>
              </ul>
            </div>

            <div className="service-item">
              <h3>Ongoing Support</h3>
              <ul>
                <li><CheckIcon /><span>Pre-trip consultation</span></li>
                <li><CheckIcon /><span>Itinerary adjustments</span></li>
                <li><CheckIcon /><span>Emergency assistance</span></li>
                <li><CheckIcon /><span>Post-trip follow-up</span></li>
                <li><CheckIcon /><span>Future trip planning</span></li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="about-social">
        <div className="container">
          <div className="social-content">
            <h2>Connect With Me</h2>
            <p>
              Follow along on my Disney adventures and get daily inspiration for your own magical journey!
            </p>
            <div className="social-links">
              <a href="https://instagram.com/magicallymousebound" target="_blank" rel="noopener noreferrer" className="social-link">
                <InstagramIcon />
                <span>@magicallymousebound</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="about-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Start Your Disney Adventure?</h2>
            <p>
              Let's work together to create the Disney vacation of your dreams.
              Contact me today to start planning your magical journey!
            </p>
            <div className="cta-buttons">
              <Link to="/contact" className="btn-primary">Contact Me</Link>
              <Link to="/blog" className="btn-secondary">View My Blog</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
